import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { filter } from 'rxjs';
import { FadeInLeft } from 'src/app/animations/FadeInLeft';
import { VerticalExpansionSlower } from 'src/app/animations/VerticalExpansion';
import { Category } from 'src/app/models/Category';
import { UserType } from 'src/app/modules/auth/models/UserType';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { PreloadAndMulticastService } from 'src/app/services/preload-and-multicast.service';
import { RouterService } from 'src/app/services/router-service.service';
import { HeaderService } from '../../services/headerservice';
import { NavigationStart, Router } from '@angular/router';
import { CartService } from 'src/app/modules/cart/services/cart.service';
import { eMyPurchasesPageTab } from 'src/app/modules/my-purchases/classes/eMyPurchasesPageTab';
import { eMySalesPageTabString } from 'src/app/modules/my-sales/classes/eMySalesPageTab';
import { NotificationsService } from 'src/app/services/notifications.service';
import { MatSnackBarService } from 'src/app/services/mat-snack-bar.service';

@Component({
	selector: 'app-mobile-header',
	templateUrl: './mobile-header.component.html',
	styleUrls: ['./mobile-header.component.scss'],
	animations: [VerticalExpansionSlower, FadeInLeft]
})
export class MobileHeaderComponent {

    bSectionsMenu = false;
	bCategoriesMenu = false;
	bUserMenu = false;

	search : FormControl;
	@ViewChild("searchInput") searchInput! : any;
	user : UserType;
	categories! : Category[];
	delay = 165;	// Delay en ms que depende de la velocidad de VerticalExpansionSlower
	cartBadgeNumber! : number;

	cNotifications? : number;

	eMyPurchasesPageTab = eMyPurchasesPageTab;
	eMySalesPageTabString = eMySalesPageTabString;

    constructor(public routerService:RouterService,
				private auth:AuthService,
				private pam:PreloadAndMulticastService,
				private headerService:HeaderService,
				private router:Router,
				private cartService:CartService,
				private notificationsService:NotificationsService,
				private matSnackBarService:MatSnackBarService) {
		this.pam.oCategories.subscribe(c=> this.categories = c);

		this.pam.oNotifications.subscribe(nl=> {
			this.cNotifications = nl.count;
		});
		this.notificationsService.oMoreNotifications.subscribe(n=> {
			this.cNotifications! += n.length;
		});

		this.search = new FormControl(undefined);
		this.auth.oUser.subscribe(u=> this.user = u);

		// Subscripción a cambios en la url. Si esta dirección no es la de la página de productos, se limpia el input
		// Si no lo limpio queda con el valor indefinidamente mientras el usuario anda por el resto de la página
		this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(v=> {
			let a : NavigationStart = <NavigationStart>v;
			if (!a.url.includes(this.routerService.SEARCH)) {
				setTimeout(() => {
					this.search.reset();
				}, 150);
			}
		});

		this.headerService.oClearSearchInput.subscribe(()=> {
			this.search.reset();
		});

		this.cartService.current.asObservable().subscribe((carts)=> {
			this.cartBadgeNumber = carts.reduce((partialSum, c) => partialSum + c.products.length, 0);
		});
    }

    onSearch() {
		this.searchInput.nativeElement.blur();
		if (this.routerService.currentRoute == this.routerService.SEARCH) {
			this.headerService.emitSearchInput(this.search.value);
		} else {
			this.routerService.toSearch(this.search.value)
		}
	}

	//#region Menus
	sectionMenuToggle() {
		if (this.bCategoriesMenu) {
			this.bCategoriesMenu = false;
			setTimeout(() => {
				this.bSectionsMenu = true;
			}, this.delay);

		} else if (this.bUserMenu) {
			this.bUserMenu = false;
			setTimeout(() => {
				this.bSectionsMenu = true;
			}, this.delay);

		} else {
			this.bSectionsMenu = !this.bSectionsMenu;
		}
	}
	openCategories() {
		this.bSectionsMenu = false;
		setTimeout(() => {
			this.bCategoriesMenu = true;
		}, this.delay);
	}
	backToSectionMenu() {
		this.bCategoriesMenu = false;
		setTimeout(() => {
			this.bSectionsMenu = true;
		}, this.delay);
	}
	closeEverything() {
		this.bSectionsMenu = false;
		this.bCategoriesMenu = false;
		this.bUserMenu = false;
	}
	//#endregion

	//#region Avatar
	onAvatarClick() {
		if (this.bCategoriesMenu) {
			this.bCategoriesMenu = false;
			setTimeout(() => {
				this.bUserMenu = true;
			}, this.delay);

		} else if (this.bSectionsMenu) {
			this.bSectionsMenu = false;
			setTimeout(() => {
				this.bUserMenu = true;
			}, this.delay);

		} else {
			this.bUserMenu = !this.bUserMenu;
		}
	}
	logout() {
		this.closeEverything();
		this.auth.logout();
		this.routerService.toHome();
		this.matSnackBarService.show("neutral", "¡Hasta la próxima!");
	}
	//#endregion

	toLogin() {
		this.closeEverything();
		this.routerService.toLogin();
	}
}
